// One clean baseline per demo document. Student notes only reach disposable clones.
export const modelOptions = {
  expectedInputs: [{ type: "text", languages: ["en"] }],
  expectedOutputs: [{ type: "text", languages: ["en"] }],
};

let baseline;
let sameDocumentDemo = false;
export function navigateDemo(url) {
  sameDocumentDemo = true;
  window.history.pushState({}, "", url);
}
export function releaseNano() {
  const old = baseline;
  baseline = null;
  if (!old) return;
  clearTimeout(old.timeout);
  old.abort.abort();
  old.session?.destroy();
}

export function prepareNano(config, { fresh = false } = {}) {
  if (fresh || (baseline && baseline.system !== config.system)) releaseNano();
  if (baseline) return baseline;
  const record = {
    system: config.system,
    started: performance.now(),
    abort: new AbortController(),
    message: "Preparing Gemini Nano…",
    downloadObserved: false,
  };
  baseline = record;
  // Do not await availability: create must start inside the button's user gesture.
  try {
    record.promise = LanguageModel.create({
      ...modelOptions,
      signal: record.abort.signal,
      initialPrompts: [{ role: "system", content: config.system }],
      monitor: (monitor) =>
        monitor.addEventListener("downloadprogress", (event) => {
          record.downloadObserved = true;
          record.message = `Preparing Gemini Nano… ${Math.round(
            event.loaded * 100,
          )}%`;
          record.onProgress?.(record.message);
        }),
    }).then((session) => {
      if (record.abort.signal.aborted) {
        session.destroy();
        throw new DOMException("Stopped", "AbortError");
      }
      record.session = session;
      record.prepared = performance.now();
      clearTimeout(record.timeout);
      // Release idle demos as well as completed/navigated ones.
      record.timeout = setTimeout(() => {
        if (baseline === record) releaseNano();
      }, 600000);
      return session;
    });
  } catch (error) {
    record.promise = Promise.reject(error);
  }
  record.timeout = setTimeout(() => {
    if (baseline === record) releaseNano();
  }, 300000);
  // A warm-up may fail before Send. Avoid an unhandled rejection; Send can retry.
  record.promise.catch(() => {
    if (baseline === record) releaseNano();
  });
  return record;
}

if (typeof window !== "undefined") {
  window.addEventListener("pagehide", releaseNano);
  window.addEventListener("popstate", () => {
    if (!sameDocumentDemo) return;
    releaseNano();
    // The demo's start transition uses pushState, not a client-side router.
    window.location.reload();
  });
}
